/**
 * API access token (v2 auth) - get/set/clear in memory and storage
 */

import { API_AUTH_TOKEN_STORAGE_KEY } from '@/components/auth/paths'

let apiAccessToken: string | null = null

function readStoredToken(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const fromSession = window.sessionStorage?.getItem(API_AUTH_TOKEN_STORAGE_KEY)
    if (fromSession) return fromSession
  } catch {
    // ignore
  }
  try {
    return window.localStorage?.getItem(API_AUTH_TOKEN_STORAGE_KEY)
  } catch {
    return null
  }
}

export function setApiAuthToken(token: string): void {
  apiAccessToken = token
  try {
    if (typeof window !== 'undefined') {
      window.sessionStorage?.setItem(API_AUTH_TOKEN_STORAGE_KEY, token)
      window.localStorage?.setItem(API_AUTH_TOKEN_STORAGE_KEY, token)
    }
  } catch (err) {
    console.error('Storage setItem', err)
  }
}

export function getApiAuthToken(): string | null {
  if (apiAccessToken) return apiAccessToken
  const stored = readStoredToken()
  if (stored) {
    apiAccessToken = stored
    return stored
  }
  return null
}

export function clearApiAuthToken(): void {
  apiAccessToken = null
  try {
    if (typeof window !== 'undefined') {
      window.sessionStorage?.removeItem(API_AUTH_TOKEN_STORAGE_KEY)
      window.localStorage?.removeItem(API_AUTH_TOKEN_STORAGE_KEY)
    }
  } catch (err) {
    console.error('Storage removeItem', err)
  }
}
